export default __webpack_public_path__ + "static/garden_design13-291ce59567177ed1ee5d66ac132f4269.webp";